import { render, staticRenderFns } from "./lable.vue?vue&type=template&id=163aae44&"
import script from "./lable.vue?vue&type=script&lang=js&"
export * from "./lable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports